/**
 * 搜索列表页插件
 */
class GroupSearchListPage {
  constructor(vue) {
    this.context = vue
    this.request_prefix = this.context.request_prefix
    this.appId = this.context.$store.state.states.getDataPageIds.appId
    this.homePageId = this.context.$store.state.states.getDataPageIds.homePageId
    this.listPageId = this.context.$store.state.states.getDataPageIds.listPageId
    this.keyWord = this.context.$store.state.states.getDataPageIds.searchKey || ""
    this.containerId = 0
    this.simpleSearchButtonId = null // 搜索按钮id
    this.enginesData = []
    this.searchTotalNum = 0
  }
  async init() {
    sessionStorage.setItem("hasSearchComponent", "1")
    // 获取所有应用
    const res = await this.context.$API.queryGroupSearchEngineList()
    if (res.data.code === 1 && res.data.data) {
      // 过滤掉name为空的数据,并且给每个数据添加label属性
      this.enginesData = res.data.data
        .filter(item => item.name)
        .map(item => {
          return {
            ...item,
            label: item.name,
            value: item.e
          }
        })
    }
    // 获取搜text索列表页数据
    this.initSimpleSearchWatcher()
    this.initNavMenuData()
    this.initNavMenuWatcher()
  }
  // 找到简单搜索组件
  findSearchComponent() {
    return this.context.$store.state[this.request_prefix].page.children[0].children.filter(rect => {
      return rect.options?.pluginName?.includes("ListPageSearchComponentPlugin")
    })[0]
  }
  // 找到列表页中的组件
  findComponent(type) {
    // 因为简单搜索组件也是自由布局组件，所以需要排除掉
    return this.context.$store.state[this.request_prefix].page.children[0].children.filter(rect => {
      return rect.shape === type && !rect.options?.pluginName?.includes("ListPageSearchComponentPlugin")
    })[0]
  }
  // 根据组件插件找到列表页中的组件
  findComponentByPlugin(pluginName) {
    // 因为简单搜索组件也是自由布局组件，所以需要排除掉
    return this.context.$store.state[this.request_prefix].page.children[0].children.filter(rect => {
      return rect.options?.pluginName?.includes(pluginName)
    })[0]
  }
  // 根据name找到列表页中的组件
  findComponentByName(name) {
    // 因为简单搜索组件也是自由布局组件，所以需要排除掉
    return this.context.$store.state[this.request_prefix].page.children[0].children.filter(rect => {
      return rect.options?.name === name && rect.shape === "cxText"
    })[0]
  }
  // 初始化筛选组件
  initNavMenuData() {
    let rectAttr = this.findComponent("cxNavMenuVertical")
    let appStageNavMenuBtnAttr = null
    let appStageNavMenuBtnIds = null
    // 如果是移动端，找到控制导航的抽屉按钮
    if (this.request_prefix === "appStage") {
      appStageNavMenuBtnAttr = this.findComponentByPlugin("listPageNavMenuDrawerPlugin")
      appStageNavMenuBtnIds = {
        container_id: this.containerId,
        rect_id: appStageNavMenuBtnAttr?.rect_id
      }
    }
    if (!rectAttr) return
    let ids = {
      container_id: this.containerId,
      rect_id: rectAttr.rect_id
    }
    this.context.$changeOptionsEV(this.enginesData, "selectOptions", false, null, ids, true)
    this.context.$changeOptionsEV(this.enginesData[0]?.e, "value", false, null, ids, true)
  }
  // 初始化搜索框事件
  initSimpleSearchWatcher() {
    // 获取展示列表的id
    const simpleSearchComponet = this.findSearchComponent()
    if (!simpleSearchComponet) return
    const uid = simpleSearchComponet.options?.rows[0]?.cols[0]?.uid
    const idPrefix = `container_id_${this.containerId}-rect_id_${simpleSearchComponet.rect_id}-uid_${uid}-elementInLayoutId_`
    this.simpleSearchInputId =
      idPrefix + simpleSearchComponet?.options?.rows[0]?.cols[0].elementOptions[0]?.elementInLayoutId
    this.simpleSearchButtonId =
      idPrefix + simpleSearchComponet?.options?.rows[0]?.cols[0].elementOptions[1]?.elementInLayoutId
    // 监听搜索输入框值变化 并赋值
    const elementInLayoutId = simpleSearchComponet?.options?.rows[0]?.cols[0].elementOptions[0]?.elementInLayoutId
    let param = {
      option_name: "inputValue",
      option_val: this.keyWord || "",
      container_id: this.containerId,
      rect_id: simpleSearchComponet.rect_id,
      elementInLayoutId: elementInLayoutId,
      uid: uid
    }
    this.context.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
    setTimeout(() => {
      const searchButton = document.getElementsByClassName(this.simpleSearchButtonId)[0]
      if (searchButton) {
        this.clickSearchButtonBind = this.clickSearchButton.bind(this)
        searchButton.addEventListener("click", this.clickSearchButtonBind, true)
      }
    }, 500)
  }
  // 初始化分类事件
  initNavMenuWatcher() {
    const self = this
    const rectAttr = self.findComponent("cxNavMenuVertical")
    const simpleSearchComponent = self.findSearchComponent()
    const emptyLayoutComponent_rect_id = self.findComponent("emptyLayoutComponent")?.rect_id
    self.context.$watch(
      function () {
        return rectAttr?.options.value
      },
      function (newVal, oldVal) {
        const searchInputValue = simpleSearchComponent?.options?.rows[0]?.cols[0].elementOptions[0]?.inputValue
        self.context.$eventBus.$emit(
          `update-layout-data-eventBus-${self.containerId}-${emptyLayoutComponent_rect_id}`,
          {
            searchKey: searchInputValue,
            groupSearchEngineInstanceId: newVal,
            isGroupSearch: true,
            isGroupSearchInit: typeof oldVal === "undefined" ? true : false,
            groupSearchInitKeys: self.enginesData.map(item => item.e)
          }
        )
      },
      {
        immediate: true
      }
    )
    self.context.$eventBus.$on(
      `update-group-search-navMenuVertical-data-eventBus-${self.containerId}-${emptyLayoutComponent_rect_id}`,
      msg => {
        if (msg) {
          // 根据groupSearchEngineInstanceId找到需要更改的数据
          let selectOptions = JSON.parse(JSON.stringify(rectAttr?.options?.selectOptions))
          if (msg.groupSearchEngineInstanceId) {
            selectOptions.map(item => {
              if (item.e === msg.groupSearchEngineInstanceId) {
                item.label = `${item.name}(${msg.totalNum})`
                item.totalNum = msg.totalNum
              }
            })
          }
          console.log("selectOptions", selectOptions)
          this.context.$changeOptionsEV(selectOptions, "selectOptions", false, null, {
            container_id: this.containerId,
            rect_id: rectAttr.rect_id
          }, true)
          // 重新计算selectOptions中的总条数
          this.searchTotalNum = selectOptions.reduce((total, item) => {
            return total + (item.totalNum || 0)
          }, 0)
          // 更新搜索总条数,
          this.updateSearchTotalNum()
        }
      }
    )
  }
  // 更新搜索总条数
  updateSearchTotalNum() {
    const rectAttr = this.findComponentByName("搜索总条数")
    this.context.$changeOptionsEV(this.searchTotalNum, "content", false, null, {
      container_id: this.containerId,
      rect_id: rectAttr.rect_id
    }, true)
  }
  clickSearchButton() {
    const emptyLayoutComponent_rect_id = this.findComponent("emptyLayoutComponent")?.rect_id
    // 获取当前搜索的值
    const searchInputValue = this.findSearchComponent()?.options?.rows[0]?.cols[0].elementOptions[0]?.inputValue
    // 通知自由布局更新数据
    this.context.$eventBus.$emit(`update-layout-data-eventBus-${this.containerId}-${emptyLayoutComponent_rect_id}`, {
      searchKey: searchInputValue,
      isGroupSearch: true,
      isGroupSearchInit: true,
      groupSearchInitKeys: this.enginesData.map(item => item.e)
    })
  }
  removeEventTrigger() {
    const searchButton = document.getElementsByClassName(this.simpleSearchButtonId)[0]
    if (searchButton) {
      searchButton.removeEventListener("click", this.clickSearchButtonBind, true)
    }
  }
}

export default {
  methods: {
    groupSearchListPagePlugin() {
      const groupSearchListPage = new GroupSearchListPage(this)
      groupSearchListPage.init()
    }
  },
  beforeDestroy() {
    this.searchListPage?.removeEventTrigger()
  }
}
